export default "__VITE_ASSET__BlEY60Ti__"